/*
 * Stages
 */
export const STAGE_LOADING = 0;
export const CHANNEL_TRAILER = 1;
export const MARKETING_VIDEO = 2;
export const STAGE_ANNOUNCEMENT = 3;
export const STAGE_HIGHLIGHT = 4;
export const STAGE_ANNOUNCEMENT_LOOP = 5;
export const STAGE_PRE_MATCH = 6;
export const STAGE_LIVE = 7;
export const STAGE_BREAK = 8;
export const STAGE_POST_MATCH = 9;
export const STAGE_WORLD_LOTTERY = 10;
export const STAGE_INITIAL = 11;


/* Sub stages */
export const OPENER = 5;
export const PRE_MATCH_STATS = 6;
export const MATCH_BREAK_STATS = 9;


/*
 * Display solutions
 */
export const DISPLAY_SOLUTION_LMT = 2;
export const DISPLAY_SOLUTION_VIDEO = 1;

/*
* Layout types
*/
export const LAYOUT_FRAME = 1;
export const LAYOUT_FULLSCREEN = 2;
export const LAYOUT_TOPBOTTOM = 10;
export const LAYOUT_MAINSIDEBAR = 11;

/*
* Odds types
*/
export const DECIMAL_ODDS = 1;
export const AMERICAN_ODDS = 2;
export const UK_ODDS = 3;

export const FRACTIONAL_ODDS = 3;

// eslint-disable-next-line max-len
export const USOddsRoundingLadder = [-1000000, -750000, -500000, -400000, -300000, -200000, -150000, -100000, -75000, -50000, -40000, -30000, -25000, -20000, -17500, -15000, -12500, -10000, -7500, -5000, -4000, -3000, -2500, -2250, -2000, -1900, -1800, -1700, -1600, -1500, -1400, -1300, -1200, -1100, -1000, -950, -900, -850, -800, -750, -725, -700, -675, -650, -625, -600, -575, -550, -525, -500, -490, -480, -470, -460, -450, -440, -430, -420, -410, -400, -390, -380, -370, -360, -350, -340, -330, -320, -310, -300, -295, -290, -285, -280, -275, -270, -265, -260, -255, -250, -248, -246, -244, -242, -240, -238, -236, -234, -232, -230, -228, -226, -224, -222, -220, -218, -216, -214, -212, -210, -208, -206, -204, -202, -200, -199, -198, -197, -196, -195, -194, -193, -192, -191, -190, -189, -188, -187, -186, -185, -184, -183, -182, -181, -180, -179, -178, -177, -176, -175, -174, -173, -172, -171, -170, -169, -168, -167, -166, -165, -164, -163, -162, -161, -160, -159, -158, -157, -156, -155, -154, -153, -152, -151, -150, -149, -148, -147, -146, -145, -144, -143, -142, -141, -140, -139, -138, -137, -136, -135, -134, -133, -132, -131, -130, -129, -128, -127, -126, -125, -124, -123, -122, -121, -120, -119, -118, -117, -116, -115, -114, -113, -112, -111, -110, -109, -108, -107, -106, -105, -104, -103, -102, -101, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 202, 204, 206, 208, 210, 212, 214, 216, 218, 220, 222, 224, 226, 228, 230, 232, 234, 236, 238, 240, 242, 244, 246, 248, 250, 255, 260, 265, 270, 275, 280, 285, 290, 295, 300, 310, 320, 330, 340, 350, 360, 370, 380, 390, 400, 410, 420, 430, 440, 450, 460, 470, 480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600, 610, 620, 630, 640, 650, 660, 670, 680, 690, 700, 710, 720, 730, 740, 750, 760, 770, 780, 790, 800, 810, 820, 830, 840, 850, 860, 870, 880, 890, 900, 910, 920, 930, 940, 950, 960, 970, 980, 990, 1000, 1025, 1050, 1075, 1100, 1125, 1150, 1175, 1200, 1225, 1250, 1275, 1300, 1325, 1350, 1375, 1400, 1425, 1450, 1475, 1500, 1525, 1550, 1575, 1600, 1625, 1650, 1675, 1700, 1725, 1750, 1775, 1800, 1825, 1850, 1875, 1900, 1925, 1950, 1975, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000, 3100, 3200, 3300, 3400, 3500, 3600, 3700, 3800, 3900, 4000, 4100, 4200, 4300, 4400, 4500, 4600, 4700, 4800, 4900, 5000, 5200, 5400, 5600, 5800, 6000, 6200, 6400, 6600, 6800, 7000, 7500, 8000, 8500, 9000, 9500, 10000, 11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 22000, 24000, 26000, 28000, 30000, 32000, 34000, 36000, 38000, 40000, 42000, 44000, 46000, 48000, 50000, 55000, 60000, 65000, 70000, 75000, 80000, 85000, 90000, 95000, 100000, 125000, 150000, 175000, 200000, 225000, 250000, 275000, 300000];
export const FractionalRoundingLadder = [
  [1, 100000], [1, 80000], [1, 66000], [1, 50000], [1, 40000], [1, 33000], [1, 28000], [1, 25000], [1, 22000],
  [1, 20000], [1, 18000], [1, 16000], [1, 14000], [1, 12000], [1, 11000], [1, 10000], [1, 8000], [1, 6600], [1, 5000],
  [1, 4000], [1, 3300], [1, 2800], [1, 2500], [1, 2200], [1, 2000], [1, 1800], [1, 1600], [1, 1400], [1, 1200],
  [1, 1100], [1, 1000], [1, 800], [1, 660], [1, 500], [1, 400], [1, 330], [1, 280], [1, 250], [1, 220], [1, 200],
  [1, 180], [1, 160], [1, 140], [1, 120], [1, 110], [1, 100], [1, 80], [1, 66], [1, 50], [1, 40],
  [1, 33], [1, 28], [1, 25], [1, 22], [1, 20], [1, 18], [1, 16], [1, 14], [1, 12], [1, 11], [1, 10], [1, 9], [2, 17],
  [2, 17], [1, 8], [2, 15], [1, 7], [1, 7], [2, 13], [2, 13], [4, 25], [1, 6], [4, 23], [2, 11], [2, 11], [4, 21],
  [1, 5], [4, 19], [4, 19], [2, 9], [2, 9], [5, 22], [5, 22], [4, 17], [4, 17], [1, 4], [1, 4], [4, 15], [5, 18],
  [2, 7], [3, 10], [5, 16], [1, 3], [6, 17], [5, 14], [4, 11], [4, 11], [5, 13], [2, 5], [5, 12],
  [10, 23], [4, 9], [5, 11], [40, 85], [10, 21], [1, 2], [8, 15], [5, 9], [4, 7], [10, 17],
  [3, 5], [8, 13], [8, 13], [5, 8], [9, 14], [4, 6], [9, 13], [7, 10], [5, 7], [8, 11],
  [17, 23], [3, 4], [10, 13], [7, 9], [4, 5], [17, 21], [5, 6], [13, 15], [10, 11], [15, 16],
  [20, 21], [32, 33], [1, 1], [33, 32], [21, 20], [16, 15], [11, 10], [15, 13], [23, 20], [6, 5],
  [21, 17], [5, 4], [9, 7], [13, 10], [27, 20], [23, 17], [11, 8], [7, 5], [10, 7], [13, 9],
  [29, 20], [6, 4], [6, 4], [31, 20], [14, 9], [8, 5], [13, 8], [17, 10], [7, 4], [9, 5],
  [9, 5], [15, 8], [19, 10], [2, 1], [21, 10], [85, 40], [11, 5], [9, 4], [23, 10], [23, 10],
  [12, 5], [5, 2], [13, 5], [21, 8], [11, 4], [14, 5], [17, 6], [3, 1], [3, 1], [31, 10],
  [31, 10], [63, 20], [16, 5], [13, 4], [33, 10], [10, 3], [67, 20], [17, 5], [69, 20], [7, 2],
  [7, 2], [18, 5], [18, 5], [37, 10], [15, 4], [4, 1], [17, 4], [22, 5], [9, 2], [47, 10],
  [19, 4], [49, 10], [5, 1], [21, 4], [53, 10], [11, 2], [23, 4], [6, 1], [25, 4], [13, 2],
  [7, 1], [15, 2], [8, 1], [17, 2], [9, 1], [10, 1], [11, 1], [12, 1], [13, 1], [14, 1],
  [15, 1], [16, 1], [17, 1], [18, 1], [19, 1], [20, 1], [22, 1], [25, 1], [28, 1], [33, 1],
  [40, 1], [50, 1], [60, 1], [66, 1], [70, 1], [80, 1], [90, 1], [100, 1], [110, 1], [120, 1],
  [125, 1], [130, 1], [140, 1], [150, 1], [160, 1], [170, 1], [175, 1], [180, 1], [190, 1], [200, 1],
  [225, 1], [250, 1], [275, 1], [300, 1], [350, 1], [400, 1], [425, 1], [450, 1], [500, 1], [550, 1],
  [600, 1], [650, 1], [700, 1], [750, 1], [800, 1], [850, 1], [900, 1], [1000, 1], [1100, 1], [1200, 1],
  [1250, 1], [1300, 1], [1400, 1], [1500, 1], [1600, 1], [1700, 1], [1750, 1], [1800, 1], [1900, 1], [2000, 1],
  [2250, 1], [2500, 1], [2750, 1], [3000, 1], [3500, 1], [4000, 1], [4250, 1], [4500, 1], [5000, 1], [5500, 1],
  [6000, 1], [6500, 1], [7000, 1], [7500, 1], [8000, 1], [8500, 1], [9000, 1], [10000, 1], [11000, 1], [12000, 1],
  [12500, 1], [13000, 1], [14000, 1], [15000, 1], [16000, 1], [17000, 1], [17500, 1], [18000, 1], [19000, 1],
  [20000, 1], [22500, 1], [25000, 1], [27500, 1], [30000, 1], [35000, 1], [40000, 1], [42500, 1], [45000, 1],
  [50000, 1], [55000, 1], [60000, 1], [65000, 1], [70000, 1], [75000, 1], [80000, 1], [85000, 1], [90000, 1],
  [100000, 1],
];

export const showMatchIdCompBlacklist = ['coderespain'];

/*
 * Crawler types
 */

export const LIVE_AND_MESSAGES = 1;
export const ONLY_MESSAGES = 2;
export const DISABLED = 3;

export const LIVE_CRAWLER_TYPE = 'liveMsg';
export const MARKETING_CRAWLER_TYPE = 'marketingMsg';
export const IMPORTANT_CRAWLER_TYPE = 'importantMsg';
export const BREAK_CRAWLER_TYPE = 'breakMsg';

/*
/* Stream types
*/
export const DASH = 'application/dash+xml';
export const DASH_ID = 3;
export const CMAF_ID = 6;

/*
/* Stream content variants
*/
export const STANDARD_STREAM_VARIANT = 1;
export const FOURSIGHT_STREAM_VARIANT = 2;


/*
/* Encoding platform types
*/
export const WOWZA = 1;
export const VT = 2;

/*
/* Error logger (front-end defined)
*/
export const DISPLAY_ERROR = 1;
export const DISPLAY_INFO = 2;
export const CONSOLE_LOG = 3;
export const DEBUG_LOG = 4;
export const ERROR_LOG = 5;
export const API_ERROR = 6;

/*
/* HTTP response status codes
*/
export const HTTP_STATUS_CODE_PAYMENT_REQUIRED = 402;
export const HTTP_STATUS_CODE_FORBIDDEN = 403;
export const HTTP_STATUS_CODE_UNAUTHORIZED_LOCATION = 403;
export const HTTP_STATUS_CODE_LOCKED = 423;
export const HTTP_STATUS_NOT_FOUND = 404;
export const HTTP_STATUS_BAD_GATEWAY = 502;
export const HTTP_STATUS_SERVICE_UNAVAILABLE = 503;

/*
/* APIs
*/
export const FISHNET = 1;
export const BCMS = 2;
export const BETSHOP_CONFIG_MAX_AGE = 5;
/*
/* Odds panel types
*/
export const ODDSPANEL_WIDGET = 2;
export const ODDSPANEL_IFRAME = 3;
